import React from 'react'

import './recipe.css'

interface IAnalyticalConstituents {
  name: string
  percentage: number
}

interface INutritionalAdditives {
  name: string
  value: number
}

export interface IAnalyticalThingProps {
  analytical: IAnalyticalConstituents[]
  nutritional: INutritionalAdditives[]
  backgroundColor: string
  allergenTitle: string
  allergenDescription: string
}

const AnalyticalThings = ({
  analytical,
  nutritional,
  backgroundColor,
  allergenTitle,
  allergenDescription
}: IAnalyticalThingProps) => {
  const getAnalytical = () => {
    if (!analytical) analytical = []

    console.log('NUTRIANT STUFF', analytical)
    return analytical.map((analyticalItem: IAnalyticalConstituents, i: number) => {
      return (
        <div className="recipe-analytical-item w-[6.5rem] rounded-md" key={`${analyticalItem.name}-${i}`}>
          <p className="pb-1 text-xs sm:text-sm">{analyticalItem.name}</p>
          <div className="recipe-divider" />
          <p className="pt-1 text-xs sm:text-sm">{analyticalItem.percentage}%</p>
        </div>
      )
    })
  }

  const getNutritional = () => {
    if (!nutritional) nutritional = []

    console.log('NUTRIANT STUFF 2', nutritional)
    return nutritional.map((item: INutritionalAdditives, i: number) => {
      return (
        <div className="recipe-nutritional-item w-[99px] rounded-md" key={`${item.name}-${i}`}>
          <p className="pb-1 text-xs sm:text-sm">{item.name}</p>
          <div className="recipe-divider" />
          <p className="pt-1 text-xs sm:text-sm">{item.value}</p>
        </div>
      )
    })
  }

  return (
    <div className="w-full p-2" style={{ backgroundColor: backgroundColor }}>
      <div className="analytical-container container mx-auto">
        <h3 className="mb-4">Analytical Constituents</h3>
        <div className="mb-8 flex flex-wrap">{getAnalytical()}</div>
        <h3 className="mb-4">Nutritional Additives (per kg)</h3>
        <div className="mb-16 flex flex-wrap">{getNutritional()}</div>
        <div className="allergens-container">
          <div className="allergen-title text-base font-bold sm:text-lg">{allergenTitle}</div>
          <div
            className="allergen-description text-sm sm:text-base"
            dangerouslySetInnerHTML={{ __html: allergenDescription }}
          ></div>
        </div>
      </div>
    </div>
  )
}

export default AnalyticalThings

export const AnalyticalThingsProps = {
  name: 'analyticalThings',
  type: 'object',
  defaultValue: {
    analytical: [],
    nutritional: []
  },
  subFields: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'analytical',
      type: 'list',
      defaultValue: [
        {
          name: 'Protein',
          percentage: 71.1
        }
      ],
      subFields: [
        { name: 'name', type: 'text', defaultValue: 'Protein' },
        { name: 'percentage', type: 'number', defaultValue: 71.1 }
      ]
    },
    {
      name: 'nutritional',
      type: 'list',
      defaultValue: [
        {
          name: 'Vitamin A',
          value: '4.5mg'
        }
      ],
      subFields: [
        { name: 'name', type: 'text', defaultValue: 'Protein' },
        { name: 'value', type: 'text', defaultValue: '4.5mg' }
      ]
    },
    {
      name: 'allergenTitle',
      type: 'string',
      defaultValue: 'Allergens'
    },
    {
      name: 'allergenDescription',
      type: 'richText',
      defaultValue: 'Allergen Description'
    }
  ]
}
